import axios from "axios";
const apiClient = axios.create({
  //  baseURL: "https://tdtlworld.com/gatep-backend/api",
  // baseURL: "http://127.0.0.1:8000/api",
  baseURL: "https://tdtlworld.com/dss-gatep-backend/api/",
  headers: {
    "Content-Type": "application/json",
  },
});

// 2. Use an interceptor to automatically add the access token to every request.
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 3. (Highly Recommended) Add an interceptor to handle token refresh automatically.
// This will make your app more robust by handling session expiration seamlessly.
apiClient.interceptors.response.use(
  (response) => response, // If the response is successful, just pass it through.
  async (error) => {
    const originalRequest = error.config;

    // Check if the error is a 401 Unauthorized and if we haven't already retried.
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; // Mark that we are retrying this request.
      const refreshToken = localStorage.getItem("refresh_token");

      if (refreshToken) {
        try {
          // Attempt to get a new access token using the refresh token.
          // Note: You might need to adjust the endpoint '/token/refresh/'.
          const { data } = await axios.post(
            `${apiClient.defaults.baseURL}/token/refresh/`,
            { refresh: refreshToken }
          );

          // Update the new access token in localStorage.
          localStorage.setItem("access_token", data.access);

          // Update the Authorization header for the original request and retry it.
          originalRequest.headers["Authorization"] = `Bearer ${data.access}`;
          return apiClient(originalRequest);
        } catch (refreshError) {
          // If the refresh token is also invalid, log the user out.
          console.error("Session expired. Please log in again.");
          localStorage.removeItem("gatep_user");
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          // Redirect to the login page.
          window.location.href = "/db-shiksha/gatep/login";
          return Promise.reject(refreshError);
        }
      }
    }

    // For any other errors, just reject the promise.
    return Promise.reject(error);
  }
);

export default apiClient;
